import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// import aboutImg from '../../images/about/about.png'; // with import
import { ImagesLoader } from '../../smart/utils/images-loader/ImagesLoader';
import { Loader } from '../utils/loader/Loader';
import './aboutarea.scss'

type props = {}

export const AboutArea = (props: any) => {

    const [isOnline, setIsOnline] = useState(false);

    useEffect(() =>

        setIsOnline(true), [setIsOnline]
    );

    if (isOnline === false) {
        return <Loader />;
    }
    else
        return  <div className="about_area ">
                    <div className="container-fluid p-0">
                        <div className="row no-gutters align-items-center">
                            <div className="col-xl-6 col-lg-6">
                                <div className="about_image">
                            <img src={ImagesLoader.AAFirst} alt=""></img>
                                </div>
                            </div>
                            <div className="col-xl-6 col-lg-6">
                                <div className="about_info">
                                    <h3>Infront Italia - Market Connect</h3>
                                    <p>I servizi Market Connect includono la fornitura di:</p>
                                    <ul>
                                <li> dati real time integrati, dati di trading, news, informazioni finanziarie e
societarie attraverso feed, terminali e soluzioni web e ‘mobile’. </li>
                                <li> dati anagrafici e storici degli strumenti quotati e non quotati accentrati
                                presso Monte Titoli (inclusi tra gli altri cedole, dividendi, corporate actions,
                                eventi, prospetti), dati del listino, dati intraday e di trading, informazioni
                                regolamentate (comunicati price sensitive e documenti), Avvisi di Borsa,
                                forniti attraverso feed grezzi e/o customizzati condotta a livello mondiale e
                                rivolta a Data Vendors, Information Providers, Banche, Intermediari
                                Finanziari, Istituzioni, SGR, Broker on line, Software House, Media,
Agenzie di stampa e Portali web finanziari con il nome “Market Connect”. </li>
                                        
                                    </ul>
                                    <div className="about_btn">
                                        {/* <a className="boxed-btn3" href="/#">About Us</a> */}
                                <Link className="boxed-btn3" onClick={() => {

                                    props.clickhandler("about")
                                }
                                } to={'/About'} > About Us </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
}


